import {
  calculateFinances,
  UserData,
  calculateSipFutureValue,
  formatRupeeLiteral,
} from '../../../constants';

const InvestmentPlanGrowthFamily = {
  label: 'Recommended Investment Plans',
  sections: [
    {
      type: 'text',
      text:
        "<br><h5>People of your age & income prefer aggressive growth<br />If saving for your child's future, try a balanced approach</h5>",
    },
    {
      type: 'cards',
      cards: [
        {
          title: "Plan your child's future (Balanced)",
          returns: '21.5',
          doubledIn: () => {
            const balancedPlan = calculateSipFutureValue(7000, 10, 16);
            return `
                Rs. ${7000} invested monthly can become up to Rs. ${formatRupeeLiteral(
              balancedPlan
            )} in 10 years`;
          },
          link: '/save/plan/24',
          linkAmount: 7000,
          planId: 24,
        },
        {
          title: 'Aggressive Growth',
          returns: '15.3',
          doubledIn: (user: UserData) => {
            const taxData = calculateFinances(user);
            const aggressivePlan = calculateSipFutureValue(
              taxData.sipAmount,
              25,
              15
            );
            return `
            Rs. ${
              taxData.sipAmount
            } invested every month can become up to Rs. ${formatRupeeLiteral(
              aggressivePlan
            )} in ${taxData.aggressiveYears} years`;
          },
          link: '/save/plan/26',
          highlighted: true,
          planId: 26,
        },
      ],
    },
    {
      type: 'text',
      text: () => {
        return `<br/>
        <small class="light">
        </small>`;
      },
    },
  ],
};

export default InvestmentPlanGrowthFamily;



// WEBPACK FOOTER //
// ./components/recommendation/cards/investmentPlanGrowthFamily.ts